import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

/** `uploaded` is the user-uploaded geo-image gallery; being on that tab is what selects this data source. */
export type DataSourceTab = 'satellites' | 'requests' | 'uploaded';

@Component({
  selector: 'app-data-source-switcher',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule],
  templateUrl: './data-source-switcher.component.html',
  styleUrls: ['./data-source-switcher.component.scss']
})
export class DataSourceSwitcherComponent {
  @Input() activeTab: DataSourceTab = 'satellites';
  @Output() tabChange = new EventEmitter<DataSourceTab>();
  setActiveTab(tab: DataSourceTab): void {
    this.activeTab = tab;
    this.tabChange.emit(tab);
  }
}
